import apiRequest from '@/js/helpers/apiRequest';
import { buildErrorCollection } from '@/js/utils/processingOpenApi';
import { ERROR_USER_PASSWORD_RECOVERY } from '@/js/utils/constants/constUser';

/**
 * Восстанавлиевает пароль пользователя по телефону
 * @param {Object} payload
 * @param {string} [payload.PHONE] - Номер телефона
 * @param {string} [payload.captchaToken]
 * @param {string} [payload.captchaAction]
 * @param {string} [payload.captchaVersion] - "rv2" | "rv3"
 * @return {Promise<unknown>}
 */
export default function userPasswordRecoveryByPhone(payload = {}) {
  return new Promise((resolve, reject) => {
    const { PHONE } = payload;
    if (!PHONE) {
      return reject(ERROR_USER_PASSWORD_RECOVERY.notPhone);
    }

    return apiRequest.post(`/user/password-recovery/?PHONE=${PHONE}`, payload)
      .then((dataRes) => {
        if (dataRes.success) {
          return resolve(dataRes?.login);
        }

        throw new Error();
      })
      .catch((e) => {
        if (e.data) {
          const errors = buildErrorCollection(e.data);
          const [firstError] = errors;
          return reject(firstError);
        }
        return reject(e);
      });
  });
}
